const actions = {
  SEARCH_REQUEST: "PROPOSAL_SLIDE_SETTING/SEARCH_REQUEST",
  SEARCH_SUCCESS: "PROPOSAL_SLIDE_SETTING/SEARCH_SUCCESS",
  SEARCH_ERROR: "PROPOSAL_SLIDE_SETTING/SEARCH_ERROR",

  DETAIL_REQUEST: "PROPOSAL_SLIDE_SETTING/DETAIL_REQUEST",
  DETAIL_SUCCESS: "PROPOSAL_SLIDE_SETTING/DETAIL_SUCCESS",
  DETAIL_ERROR: "PROPOSAL_SLIDE_SETTING/DETAIL_ERROR",

  CREATE_REQUEST: "PROPOSAL_SLIDE_SETTING/CREATE_REQUEST",
  CREATE_SUCCESS: "PROPOSAL_SLIDE_SETTING/CREATE_SUCCESS",
  CREATE_ERROR: "PROPOSAL_SLIDE_SETTING/CREATE_ERROR",

  UPDATE_REQUEST: "PROPOSAL_SLIDE_SETTING/UPDATE_REQUEST",
  UPDATE_SUCCESS: "PROPOSAL_SLIDE_SETTING/UPDATE_SUCCESS",
  UPDATE_ERROR: "PROPOSAL_SLIDE_SETTING/UPDATE_ERROR",

  DELETE_REQUEST: "PROPOSAL_SLIDE_SETTING/DELETE_REQUEST",
  DELETE_SUCCESS: "PROPOSAL_SLIDE_SETTING/DELETE_SUCCESS",
  DELETE_ERROR: "PROPOSAL_SLIDE_SETTING/DELETE_ERROR",

  EXECUTE_REQUEST: "PROPOSAL_SLIDE_SETTING/EXECUTE_REQUEST",
  EXECUTE_SUCCESS: "PROPOSAL_SLIDE_SETTING/EXECUTE_SUCCESS",
  EXECUTE_ERROR: "PROPOSAL_SLIDE_SETTING/EXECUTE_ERROR",

  RESET_DETAIL: "PROPOSAL_SLIDE_SETTING/RESET_DETAIL",

  search: (payload) => ({
    type: actions.SEARCH_REQUEST,
    payload,
  }),

  getDetail: (payload) => ({
    type: actions.DETAIL_REQUEST,
    payload,
  }),

  create: (payload) => ({
    type: actions.CREATE_REQUEST,
    payload,
  }),

  update: (payload) => ({
    type: actions.UPDATE_REQUEST,
    payload,
  }),

  delete: (payload) => ({
    type: actions.DELETE_REQUEST,
    payload,
  }),

  execute: (payload) => ({
    type: actions.EXECUTE_REQUEST,
    payload,
  }),

  resetDetail: () => ({
    type: actions.RESET_DETAIL,
  }),
};

export default actions;
